import React from "react";
import {
  ShieldCheck,
  Cpu,
  Users,
  TrendingUp,
  Clock,
  Repeat,
} from "lucide-react";
import CTASection from "../../common/CTASection";

const benefits = [
  {
    icon: <Users className="h-6 w-6 text-[#0E668F]" />,
    title: "Responsive Support",
    text: "Accessible & Responsive Support enhances productivity",
  },
  {
    icon: <Cpu className="h-6 w-6 text-[#0E668F]" />,
    title: "Diverse Expertise",
    text: "Diverse Expertise ensures all support needs are met",
  },
  {
    icon: <TrendingUp className="h-6 w-6 text-[#0E668F]" />,
    title: "Proactive Cost Reduction",
    text: "Reduce costs through a proactive support model",
  },
  {
    icon: <ShieldCheck className="h-6 w-6 text-[#0E668F]" />,
    title: "Security & Stability",
    text: "Stabilize and secure your environment",
  },
  {
    icon: <Clock className="h-6 w-6 text-[#0E668F]" />,
    title: "Reliable Support",
    text: "Guaranteed Service Levels when you need support",
  },
  {
    icon: <Repeat className="h-6 w-6 text-[#0E668F]" />,
    title: "Continuous Improvement",
    text: "Ongoing business reviews to improve service",
  },
];

const WhyChooseUs = () => {
  return (
    <div>
      <section className="bg-gradient-to-b from-white to-blue-50 py-14 px-4 sm:px-8 md:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-extrabold text-[#0E668F] leading-tight">
              当社を選ぶ理由 
            </h2>
            <p className="text-lg md:text-xl mt-4 text-gray-700 max-w-3xl mx-auto font-medium">当社のマネージド サービスを利用してテクノロジーを加速し、</p>
              <p className="text-lg md:text-xl mt-4 text-gray-700 max-w-3xl mx-auto font-medium">ビジネスの成長を促進しましょう。</p>
          </div>
          {/* Security Commitment */}
          <div className="mt-16 bg-white p-6 sm:p-10 rounded-2xl shadow-md">
            <h3 className="text-2xl sm:text-3xl font-semibold text-[#0E668F] mb-4">
             当社のセキュリティへの取り組み
            </h3>
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              <strong>DG FutureTech</strong> では、お客様のデータの保護を最優先に考えています。当社は、組織、運用、ポリシーの各レベルにわたって強力なセキュリティ対策を実施し、お客様のデータ、アプリケーション、インフラストラクチャを確実に保護して、ビジネスの安全性と回復力を維持します。
            </p>
          </div>

          {/* Business Message */}
          <div className="mt-10 bg-blue-100 p-6 sm:p-10 rounded-2xl shadow-inner">
            <h3 className="text-2xl sm:text-3xl font-semibold text-[#0E668F] mb-4">
              DG FutureTech: ビジネスの成功に向けたITの強化
            </h3>
            <p className="text-gray-800 text-base sm:text-lg leading-relaxed mb-3">
              今日のデジタル世界では、ITインフラストラクチャとアプリケーションはビジネスの肝です。コアシステムからカスタムアプリケーションに至るまで、信頼性が高く、拡張性と柔軟性に優れたテクノロジー環境の有無が、御社のビジネス目標を達成し、顧客の期待を上回る成果を示すことに直接関わってきます。
            </p>
            <p className="text-gray-800 text-base sm:text-lg leading-relaxed mb-3">
              DG FutureTechでは、テクノロジーをお客様のために活用することに特化しています。信頼に足るマネージドサービスおよびアプリケーション開発パートナーとして、当社は御社のITインフラストラクチャを最適化し、独自のニーズに合わせた強力でスケーラブルなアプリケーションの構築を支援します。当社は、一貫したアプローチにより、最大限の効率、セキュリティ、俊敏性を保証し、お客様のさらなる革新と成長を促します。
            </p>
            <p className="text-gray-800 text-base sm:text-lg leading-relaxed">
              成功を手中に収めるため、今すぐDG FutureTechとの提携をご検討ください。当社にお問い合わせいただければ、当社のITエキスパートおよびアプリケーション開発ソリューションが御社のビジネスにいかに貢献できるか、ご説明させていただきます。
            </p>
          </div>
        </div>
      </section>
       {/* CTA Section */}
        
    </div>
  );
};

export default WhyChooseUs;